import axiosInstance from '../axiosInterceptor/axiosInstance'

// The federation competitions a club team is paired into that the caller may browse read-only
// (the club holds ViewStats; the caller is its Owner, an Admin or a Manager), with the
// federation whose routes read them and the season to open on. Empty for anyone else, including a
// member who may not read the club's teams (a refusal): the sidebar just has nothing to add, so no
// error toast.
const getPairedCompetitions = async (orgId, clubTeamId) => {
  try {
    const response = await axiosInstance.get(`v1/orgs/${orgId}/pairings/competitions`, {
      params: { clubTeamId },
      skipErrorNotification: true,
    })
    return response?.data ?? []
  } catch (error) {
    if ([401, 403].includes(error?.response?.status)) return []
    throw error
  }
}

export default getPairedCompetitions
